import { createContext, useState, useContext} from 'react';

const ControlCentreContext = createContext();

function ControlCentreProvider({ children }) {

    const [controlCentre, setControlCentre] = useState(() => {
        const storedData = localStorage.getItem('controlCentre');
        return storedData ? JSON.parse(storedData) : null;
    });

    const updateControlCentre = (newControlCentre) => {
        setControlCentre(newControlCentre);
        localStorage.setItem('controlCentre', JSON.stringify(newControlCentre));
        
    }

    return (
        <ControlCentreContext.Provider value={{controlCentre, updateControlCentre}}> 
            {children}
        </ControlCentreContext.Provider>
    )
}

function useControlCentreContext() {
    const context = useContext(ControlCentreContext);
    return context;
}

export {ControlCentreProvider, useControlCentreContext};